export default __webpack_public_path__ + "static/media/letter-template-2.28d5f3b2.docx";